module.exports = __webpack_public_path__ + "static/media/allow_cam_mic.e06aeccb.png";